// wealth built at the end of the given years from the lumpsum, the monthly SIP and the planned changes, worked out year by year
// every year the wealth grows by the annual return, the SIP of that year adds 12 months of SIP that earn half a year of the return on average
// the planned investments (+) and withdrawals (-) of a year are applied at the end of that year, a withdrawal is limited to the wealth available then
// planned changes outside the 1st to the last year are not counted
export const _getWealthCorpus = (lumpsum, monthly_sip, annual_return, years, planned_changes, current_year) => {
    const annual_rate = (Number(annual_return) || 0) / 100;
    const yearly_sip = (Number(monthly_sip) || 0) * 12 * (1 + annual_rate / 2);

    let corpus = Number(lumpsum) || 0;
    for (let year = 1; year <= years; year++) {
        corpus = corpus * (1 + annual_rate) + yearly_sip;

        planned_changes.forEach((change) => {
            if (change.year - current_year !== year) {
                return;
            }

            const amount = Number(change.amount) || 0;
            if (change.type === "withdraw") {
                corpus = Math.max(corpus - amount, 0);
            } else {
                corpus += amount;
            }
        });
    }

    return Math.round(corpus);
};
